import { Box, BoxProps, Divider, Flex, Stack, StackProps } from '@chakra-ui/react';
import { rem } from 'polished';
import { PropsWithChildren } from 'react';

type Props = BoxProps & {
  testId?: string;
  rightRender?: any;
  stackProps?: StackProps;
};

export const TabsBarWrapper = ({
  testId,
  children,
  rightRender,
  stackProps,
  ...boxProps
}: PropsWithChildren<Props>) => (
  <Box overflow="hidden" {...boxProps}>
    <Flex
      justifyContent="space-between"
      height={{ base: rem(40), md: rem(44) }}
      overflowY="hidden"
      overflowX="auto"
    >
      <Stack
        direction="row"
        position="relative"
        gap={{ base: 'space.16', md: 'space.32' }}
        data-testid={`${testId}-list`}
        borderColor="transparent"
        {...stackProps}
      >
        {children}
      </Stack>
      {rightRender}
    </Flex>
    <Divider mx="0" mb="0" mt="-1px" opacity={1} transition="opacity 120ms ease-in-out" />
  </Box>
);
